/* The dashboard.
 *
 * One request answers the whole screen: the jobs this person is on, and — for
 * the office — the shop at a glance. There is no role in the path and none in
 * the query; the server decides which half it owes the caller, so a client that
 * asked for the office's numbers would simply be handed null.
 *
 * `liveStages` goes up for the same reason the customers list sends it: "in the
 * shop" is a flag on the stage list and a job stores an id, so the client
 * resolves the flags and sends ids. The server has the stages itself now, so
 * this is the next thing to go. */
import type { DashboardDto, DashboardQuery } from '@oneshot2pac/shared';
import { api } from './client';
import { queryString } from './query';

export const dashboardApi = {
  get: (query: DashboardQuery = {}) =>
    api.get<DashboardDto>(`/dashboard${queryString({ ...query })}`),
};
